const setVars = () => {
	const doc = document.documentElement
	const header = document.querySelector('.header')
	const navFooter = document.querySelector('.nav__footer')
	const experienceTitle = document.querySelector('.experience__title')
	// const experienceTabNav = document.querySelector('.experience-tabs__nav')

	const appHeight = () => {
		doc.style.setProperty('--app-height', `${window.innerHeight}px`)
	}
	const headerHeight = () => {
		doc.style.setProperty('--header-height', `${header.clientHeight}px`)
	}
	const navMenuFooter = () => {
		doc.style.setProperty('--nav-footer-height', `${navFooter.clientHeight}px`)
	}
	const experienceTitleHeight = () => {
		setTimeout(() => {
			doc.style.setProperty('--experience-title-height', `${experienceTitle.clientHeight - experienceTitle.clientHeight}px`)
		}, 300);
	}

	appHeight()
	if (header) {
		headerHeight()
	}
	if (navFooter) {
		navMenuFooter()
	}
	if (experienceTitle && experienceTitle) {
		experienceTitleHeight()
	}
}
window.addEventListener('DOMContentLoaded', setVars)
window.addEventListener('resize', setVars)

